import { AskUserQuestionTool } from '#plugin-chat/components/tools/ask-user-question/AskUserQuestionTool.tsx';
import { CreateResponseTool } from '#plugin-chat/components/tools/create-response/CreateResponseTool.tsx';
import { DescribeViewsTool } from '#plugin-chat/components/tools/describe-views/DescribeViewsTool.tsx';
import { PlanTool } from '#plugin-chat/components/tools/plan/PlanTool.tsx';
import { QueryKnowledgeGraphTool } from '#plugin-chat/components/tools/query-knowledge-graph/QueryKnowledgeGraphTool.tsx';
import { ShowDashboardTool } from '#plugin-chat/components/tools/show-dashboard/ShowDashboardTool.tsx';
import { ShowInsightsTool } from '#plugin-chat/components/tools/show-insights/ShowInsightsTool.tsx';
import { TransformDatasetTool } from '#plugin-chat/components/tools/transform-dataset/TransformDatasetTool.tsx';

/** Aggregated namespace of tool UI components for rendering LLM tool invocations in the chat interface. */
export const Tool = {
  AskUserQuestion: AskUserQuestionTool,
  CreateResponse: CreateResponseTool,
  DescribeViews: DescribeViewsTool,
  Plan: PlanTool,
  QueryKnowledgeGraph: QueryKnowledgeGraphTool,
  ShowDashboard: ShowDashboardTool,
  ShowInsights: ShowInsightsTool,
  TransformDataset: TransformDatasetTool,
} as const;

export type ToolProps = {
  name: string;
};
